import { useRef } from "react";
import { ScrollTrigger, useGSAP } from "../animations/gsapSetup.ts";

export function useGsapScrollTrigger(
  animation: (el: HTMLElement) => void,
  deps: React.DependencyList = [],
) {
  const ref = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const el = ref.current;
      if (!el) return;
      animation(el);
    },
    { scope: ref, dependencies: deps as unknown[], revertOnUpdate: true },
  );

  return ref;
}

export function useScrollTriggerRefresh() {
  useGSAP(
    () => {
      const timer = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
      return () => clearTimeout(timer);
    },
    { dependencies: [] },
  );
}
